/*
 *
 * Furniture constants
 *
 */

import { API_BASE_URL } from 'containers/App/constants';

enum ActionTypes {
  PIECES_REQUEST = 'app/CONFIGURATOR/PIECES/PIECES_REQUEST',
  PIECES_SUCCESS = 'app/CONFIGURATOR/PIECES/PIECES_SUCCESS',
  PIECES_FAILURE = 'app/CONFIGURATOR/PIECES/PIECES_FAILURE',
}

export const PIECES_URL = `${API_BASE_URL}/pieces`;

export default ActionTypes;
